import React, { Suspense, useRef, useState } from "react";
import Galaxy from "./Galaxy";
import './UniverseApp.css'
import { Effects, Html } from "@react-three/drei";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
import { useStateValue } from "../utils/provider/StateProvider";


import universeRawData from "./data/universe.json";





const PlanetryDot = ({name, position }) => {
  // Hide on basic of camera:

  // useFrame(({ camera }) => {
  //   // Access the z-coordinate of the object
  //   const objectZ = camera.position.z;

  //   // Set a threshold value for hiding the object
  //   const hideThreshold = 20;

  //   // Update visibility based on the z-coordinate
  //   if (objectZ > hideThreshold) {
  //     meshRef.current.visible = false;
  //   } else {
  //     meshRef.current.visible = true;
  //   }
  // });

  const updatePosition = [position[0], position[1]/100, position[2]]

  return (
    <group dispose={null}  position={updatePosition}>
      <mesh>
        <sphereGeometry args={[0.009, 32, 32]} />
        {/* <meshBasicMaterial color="white" /> */}
      </mesh>

      {/* <Effects disableGamma>
        <unrealBloomPass threshold={1} strength={0.4} radius={0} />
        <outputPass args={[THREE.ACESFilmicToneMapping]} />
      </Effects> */}


      <Html>
        <div className="planetDisplayName">
          <p id="planetNameClicked" style={{ fontSize: "8px", color: "white", width: "200px", cursor: 'pointer'}}>{name}</p>
        </div>
      </Html>
    </group>
  );
};



function Nucleus({ size }) {
  const nucleusRef = useRef();
  const color = new THREE.Color();
  color.setHSL(Math.random(), 0.7, Math.random() * 0.2 + 0.05);

  return (
    <mesh ref={nucleusRef} position={[0, 0, 0]} scale={[size, size, size]}>
      <sphereGeometry attach="geometry" args={[0.5, 32, 32, 0, 6.4, 0, 6.3]} />
      <meshBasicMaterial attach="material" color={"#fff"} />
    </mesh>
  );
}

function GalaxySystem({galaxy, name, selectedGalaxy, onChangeGalaxyView}) {
  
  // arguments:
  const galaxyData = galaxy;
  const galaxyName = name;
  const galaxyTilt = (parseInt(galaxy.data.right_ascension.split(":")) * Math.PI) / 180; // Convert hours to radians


  const [{showInfo}, dispatch] = useStateValue();

  const dof = useRef();
  const galaxySystemMesh = useRef();

  const meshRef = useRef(null);

  // This function creates position of galaxy with ref to milkyway:
  const createPositions = (data) => {
    const ra = data.right_ascension.split(":");
    const decDegree = data.declination.split(":");
    const distance = data.distance;

    const raDegrees =
      parseInt(ra[0]) + parseInt(ra[1]) / 60 + parseInt(ra[2]) / 3600;

    const decDegrees =
      parseInt(decDegree[0]) +
      parseInt(decDegree[1]) / 60 +
      parseInt(decDegree[2]) / 3600;

    const raRadians = (raDegrees * Math.PI) / 180;
    const decRadians = (decDegrees * Math.PI) / 180;
    const x = distance * Math.cos(decRadians) * Math.cos(raRadians);
    const y = distance * Math.cos(decRadians) * Math.sin(raRadians);
    const z = distance * Math.sin(decRadians);

    return [x, y, z];
  };

  // Create the Bloom based on redshift value:
  const getColorIntensity = (redshift) => {
    if (redshift === "N/A") {
      return { color: "red", intensity: 4 };
    }

    const rangeOfRedShift = (shift) => {
      // Positive redshift:
      if (shift > 1000) {
        return (shift / 1000) * (2 / 5);
      } else if (shift <= 1000 && shift > 500) {
        return (shift / 200) * (2 / 3);
      }

      // Negative redshift:
      if (shift < 0) {
        return -shift * 100;
      }
    };

    if (parseFloat(redshift) < 0) {
      return {
        color: "blue",
        intensity: 4 * rangeOfRedShift(parseFloat(redshift)),
      };
    }

    return {
      color: "red",
      intensity: 4 * rangeOfRedShift(parseFloat(redshift)),
    };
  };

  // Galaxy Position:
  const galaxyCoord =
    galaxyName === selectedGalaxy ? [0, 0, 0] : createPositions(galaxyData.data);


    useFrame(() => {
      if (typeof galaxySystemMesh.current !== "undefined") {
        galaxySystemMesh.current.rotation.y += 0.001;

        // Apply tilt
        if(galaxyData.data.style.length === 1){
          if (galaxyName !== selectedGalaxy) {
            galaxySystemMesh.current.rotation.x = galaxyTilt +20;
            galaxySystemMesh.current.rotation.z = galaxyTilt + -10;
          
          } 
        }else{
          if(galaxyData.data.style[1].hasOwnProperty("angle")){
            galaxySystemMesh.current.rotation.z = galaxyData.data.style[1].angle
            galaxySystemMesh.current.rotation.y = 0
          }
        }
      }
    });


  const onGalaxyClicked = () => {
    // Set the galaxy view:
    onChangeGalaxyView(name, galaxyCoord) 

    // View Galaxy modal:
    dispatch({
      type: "SHOW_INFO",
      showInfo: true
    }) 
  }


  const system = universeRawData[selectedGalaxy].systems

  let planetrySystems = {}
  Object.keys(system).map(i => {
    if(system[i].hasOwnProperty("data")){
      const position = createPositions(system[i].data)
      planetrySystems[i] = {
        "name": system[i].data.name,
        "position": position
      }
    }
  })


  // Show description on hovering the galaxy name:
  const [showDescOnHover, setShowDescOnHover] = useState(false)
  const handleHoverDesc = (name) => {
    if(name === selectedGalaxy){
      return
    }

    console.log(name, selectedGalaxy)
    setShowDescOnHover(true)
  }

  const closeHoverDesc = (name) => {
      setShowDescOnHover(false)
  }


  return (
    <mesh>
      <group>
        <mesh ref={meshRef} position={galaxyCoord}>
          {galaxyName === selectedGalaxy ?
            galaxyData.data.style.map(i => (
              <mesh ref={galaxySystemMesh} position={i && i.position}>
                <Suspense fallback={null}>
                  <Galaxy dof={dof} galaxy={galaxyData} name={galaxyName} style={i}/>
                  <Nucleus size={0.125} />
                </Suspense>
                <Effects ref={dof} />
              </mesh>
            )
            )
           : (
            <group  dispose={null}>

              <mesh ref={galaxySystemMesh} position={[0, 0, 0]}>
                {/* <sphereGeometry args={[1, 32, 32]} />
                <meshStandardMaterial
                  color={getColorIntensity(galaxyData.data.redshift).color}
                  emissive={getColorIntensity(galaxyData.data.redshift).color}
                  emissiveIntensity={
                    getColorIntensity(galaxyData.data.redshift).intensity
                  }
                  toneMapped={false}
                /> */}

            {/* <group  dispose={null}>
                {galaxyData.data.style.map(i => (
                  <mesh ref={galaxySystemMesh}>
                    <Suspense fallback={null}>
                      <Galaxy dof={dof} galaxy={galaxyData} name={galaxyName} style={i} />
                      <Nucleus size={0.125} />
                    </Suspense>
                    <Effects ref={dof} />
                  </mesh>
                )
                )}
              </group> */}
                
              </mesh>
            </group>
          )
          }


          {/* Showing Solar systems in the Galaxy */}
          {galaxyName === selectedGalaxy && 
            Object.keys(planetrySystems).map(system => (
              <PlanetryDot name={planetrySystems[system].name} position={planetrySystems[system].position} />
            ))
          }
          <Html>
            <div className="planetDisplayName" onClick={() => onGalaxyClicked()}>
              <p id="planetNameClicked" style={{ fontSize: "12px", color: "white", minWidth: "50px", width: "max-content", cursor:'pointer'}} onMouseOver={() => handleHoverDesc(name)} onMouseLeave={() => closeHoverDesc(name)}>{universeRawData[name].data.name}</p>
              {showDescOnHover && <p className="hoverGalaxyDesciption" style={{color: "white"}}>{universeRawData[name].data?.hoverText}</p>}
            </div>
          </Html>
            
        </mesh>
      </group>
    </mesh>
  );
}

export default GalaxySystem;



// {/* Redshift dot */}
// {/* <mesh ref={meshRef} position={[0, 0, 0]}>
//   <sphereGeometry args={[2, 32, 32]} />
//   <meshStandardMaterial
//     color={getColorIntensity(galaxyData.data.redshift).color}
//     emissive={getColorIntensity(galaxyData.data.redshift).color}
//     emissiveIntensity={
//       getColorIntensity(galaxyData.data.redshift).intensity
//     }
//     toneMapped={false}
//   />
// </mesh>
// <Effects disableGamma>
//   <unrealBloomPass threshold={2} strength={0.1} radius={10} />
//   <outputPass args={[THREE.ACESFilmicToneMapping]} />
// </Effects>
//   */}



// Conplete Galaxy:
// {/* 
  // <group {...props} dispose={null}>
  //   {galaxyData.data.style.map(i => (
  //     <mesh ref={galaxySystemMesh}>
  //       <Suspense fallback={null}>
  //         <Galaxy dof={dof} galaxy={galaxyData} name={galaxyName} style={i} />
  //         <Nucleus size={0.125} />
  //       </Suspense>
  //       <Effects ref={dof} />
  //     </mesh>
  //   )
  //   )}
  // </group> 
// */}